import { I18n } from '~/constants/I18n';

export const getAirTabTitle = (title: string | undefined) => {
  if (!title) {
    return undefined;
  }

  return `${title} | ${I18n.basePageShortTitle}`;
};
